import React from "react";
import { Link } from "react-router-dom";

import PersonAvatar from "../0. Utilidades/PersonAvatar";

const PersonaIniciativa = ({ persona, detalle, tone, compact = false, to, onClick }) => {
  if (!persona) return null;

  const avatarTone = tone || (persona.tipo === "maestra" ? "maestra" : "persona");
  const interactive = Boolean(to || onClick);
  const className = `initiative-person-identity${compact ? " initiative-person-identity--compact" : ""}${interactive ? " initiative-person-identity--link" : ""}${onClick ? " initiative-person-identity--button" : ""}`;

  const content = (
    <>
      <PersonAvatar
        src={persona.imagen}
        name={persona.nombre}
        alt={`Fotografía de ${persona.nombre}`}
        className="initiative-person-avatar"
        tone={avatarTone}
      />
      <span className="initiative-person-copy">
        <strong>{persona.nombre}</strong>
        {detalle && <small>{detalle}</small>}
      </span>
    </>
  );

  if (onClick) {
    return <button type="button" className={className} onClick={onClick} title={`Ver ficha de ${persona.nombre}`}>{content}</button>;
  }
  return to
    ? <Link className={className} to={to} title={`Abrir ficha de ${persona.nombre}`}>{content}</Link>
    : <div className={className}>{content}</div>;
};

export default PersonaIniciativa;
